import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Button, Modal, Input, Form, Select, DatePicker } from "antd";
import { getAllUsers, getUserAllowedPartners, addUser } from '../../../actions/UsersActions';
import { getAffiliatesInfo } from '../../../actions/AffiliateActions';
import { getLanguages } from '../../../actions/settings/LanguagesActions';
import { getCurrencies } from '../../../actions/settings/CurrencyActions';
import RegularExpression from '../../../constants/RegularExpression';
import moment from 'moment';

const { Option } = Select;

/**
* Enum for Checking Date type.
* @readonly
* @enum {number}
*/

export const dateTypeEnum = {
    Forever: 1,
    Date: 2
}

class AddUser extends React.Component {
    state = {
        isAddModalvisible: false,
        editUserModal: { visible: false },

        firstName: '',
        lastName: '',
        sub: null,

        editStatus: '',

        expireType: dateTypeEnum.Forever,
        pageNumber: 1,
        selectedMainPartnerId: null
    };

    componentDidMount() {
        const { mainPartnerId, userId } = this.props.user;
        const { pageNumber } = this.state;

        this.props.dispatch(getAllUsers(mainPartnerId, pageNumber));
        this.props.dispatch(getAffiliatesInfo(mainPartnerId));
        this.props.dispatch(getLanguages());
        this.props.dispatch(getCurrencies());
        this.props.dispatch(getUserAllowedPartners(userId));
    }

    disabledStartDate = StartValue => {
        // disable date that is smaller than current
        return StartValue && StartValue < moment().startOf('day');
    };

    disabledEndDate = EndValue => {
        const values = this.props.form.getFieldsValue();
        const date = moment().diff(values.startDate, 'days') < 0 ? values.startDate : moment().startOf('days');
        return EndValue && EndValue < date
    };

    onChange = (field, value) => {
        this.setState({ [field]: value });
    };

    onStartChange = value => {
        this.onChange('StartValue', value);
    };

    onEndChange = value => {
        this.onChange('EndValue', value);
    };

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    };

    changeExpireType = (value) => {
        this.setState({ expireType: value })
    };

    showModal = () => {
        this.setState({ visible: true });
    };

    handleCancel = e => {
        this.props.form.resetFields();
        this.setState({ visible: false });
    };

    handleAddUser = (form) => {
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state

        //Validate completed data
        form.validateFields((err, values) => {
            if (!err) {
                const sendValues = {
                    ...values,
                    mainPartners: [values.mainPartners]
                }

                this.props.dispatch(addUser(sendValues, mainPartnerId)).then(() => {
                    this.props.dispatch(getAllUsers(mainPartnerId, pageNumber))
                })
            }
            this.handleCancel();
        });
    };

    handleMainAffChange = () => {
        const { getFieldsValue } = this.props.form;

        setTimeout(() => {
            const fields = getFieldsValue();

            this.setState({
                selectedMainPartnerId: fields.mainPartners
            })
            this.props.dispatch(getAffiliatesInfo(this.state.selectedMainPartnerId));


        }, 0)
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { affiliatesInfo } = this.props.affiliates;
        const languageList = this.props.languages.data;
        const currenciesList = this.props.currencies.data;
        const { allowedPartners } = this.props.affUser;

        const dateFormat = "YYYY-MM-DD";

        const languages = languageList && Object.keys(languageList).map((key) =>
            <Option key={key} value={key}>{languageList[key]}</Option>
        );

        const currencies = currenciesList && Object.keys(currenciesList).map((key) =>
            <Option key={key} value={key}>{currenciesList[key]}</Option>
        );

        const subAffiliates = affiliatesInfo && Object.keys(affiliatesInfo).map((key) =>
            <Option key={key} value={key}>{affiliatesInfo[key]}</Option>
        );

        const allowedPartnerList = allowedPartners && Object.keys(allowedPartners).map((key) =>
            <Option key={allowedPartners[key].PartnerId} value={allowedPartners[key].PartnerId}>{allowedPartners[key].PartnerName}</Option>
        );

        return (
            <React.Fragment>
                <Button type="primary" onClick={this.showModal}>{this.props.intl.messages.add_user}</Button>
                <Modal
                    title={this.props.intl.messages.add_user}
                    visible={this.state.visible}
                    onCancel={this.handleCancel}
                    centered
                    className='ta--add-user_modal'
                    footer={[
                        <React.Fragment>
                            <Button onClick={this.handleCancel} key="cancel">{this.props.intl.messages.cancel}</Button>
                            <Button onClick={this.handleAddUser.bind(this, this.props.form)} key="save" type="primary">{this.props.intl.messages.save}</Button>
                        </React.Fragment>
                    ]}
                >
                    <Form className='ta--flex'>
                        <div className='ta--mh-12 ta--col-6'>
                            <Form.Item label={this.props.intl.messages.main_partner}>
                                {getFieldDecorator('mainPartners', {
                                    rules: [{
                                        required: true,
                                        message: this.props.intl.messages.required_field
                                    }],
                                })(
                                    <Select className='ta-w100' onChange={this.handleMainAffChange}>
                                        {allowedPartnerList}
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.sub_affiliate}>
                                {getFieldDecorator('affiliates', {
                                    rules: [{
                                        required: true,
                                        message: this.props.intl.messages.required_field
                                    }],
                                })(
                                    <Select mode="multiple" className='ta-w100'>
                                        {subAffiliates}
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.password}>
                                {getFieldDecorator('password', {
                                    rules: [
                                        { required: true, message: this.props.intl.messages.required_field },
                                        { pattern: RegularExpression.PASSWORD_VALIDATION, message: this.props.intl.messages.invalid_password },
                                    ],
                                })(
                                    <Input type="password" />
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.select_currency}>
                                {getFieldDecorator('currencyId', {
                                    rules: [{
                                        required: true,
                                        message: this.props.intl.messages.required_field,
                                    }],
                                })(
                                    <Select className='ta-w100'>
                                        {currencies}
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.select_state}>
                                {getFieldDecorator('status', {
                                    rules: [{
                                        required: true,
                                        message: this.props.intl.messages.required_field
                                    }],
                                })(
                                    <Select className='ta-w100'>
                                        <Option
                                            value={this.props.intl.messages.active}>{this.props.intl.messages.active}</Option>
                                        <Option
                                            value={this.props.intl.messages.inactive}>{this.props.intl.messages.inactive}</Option>
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.date}>
                                {getFieldDecorator('typeOfDateRange', {
                                    initialValue: dateTypeEnum.Forever,
                                    rules: [
                                        { required: true, message: this.props.intl.messages.required_field }]
                                })(
                                    <Select className='ta-w100' onChange={this.changeExpireType}>
                                        <Option value={dateTypeEnum.Forever}>{this.props.intl.messages.forever}</Option>
                                        <Option value={dateTypeEnum.Date}>{this.props.intl.messages.date}</Option>
                                    </Select>
                                )}
                            </Form.Item>

                            {/* Render StartDate if date type is 'date' */}
                            {this.state.expireType === dateTypeEnum.Date ? (
                                <Form.Item label={this.props.intl.messages.start_date}>
                                    {getFieldDecorator('startDate')(
                                        <DatePicker
                                            disabledDate={this.disabledStartDate}
                                            format={dateFormat}
                                            placeholder={this.props.intl.messages.start_date}
                                            onChange={this.onStartChange}
                                            onOpenChange={this.handleStartOpenChange}
                                        />
                                    )}
                                </Form.Item>
                            ) : (null)}

                            {/* Render EndDate if date type is 'date' */}
                            {this.state.expireType === dateTypeEnum.Date ? (
                                <Form.Item label={this.props.intl.messages.end_date}>
                                    {getFieldDecorator('endDate', {
                                        rules: [{
                                            validator: (rule, value, callback) => {
                                                const values = this.props.form.getFieldsValue()
                                                if (!value) {
                                                    callback(this.props.intl.messages.end_date_validation_message);
                                                } else if (values.startDate.diff(value, 'days') > 0) {
                                                    callback(this.props.intl.messages.end_date_validation_message);
                                                } else {
                                                    this.props.form.validateFields(['endTime'], { force: true })
                                                    callback();
                                                }
                                            }
                                        }],
                                    })(
                                        <DatePicker
                                            disabledDate={this.disabledEndDate}
                                            format={dateFormat}
                                            placeholder={this.props.intl.messages.end_date}
                                            onChange={this.onEndChange}
                                            onOpenChange={this.handleEndOpenChange}
                                        />
                                    )}
                                </Form.Item>
                            ) : (null)}
                        </div>

                        <div className='ta--mh-12 ta--col-6'>
                            <Form.Item label={this.props.intl.messages.select_type}>
                                {getFieldDecorator('type', {
                                    rules: [{
                                        required: true,
                                        message: this.props.intl.messages.required_field
                                    }],
                                })(
                                    <Select className='ta-w100'>
                                        {/* <Option value={this.props.intl.messages.main_partner}>{this.props.intl.messages.main_partner}</Option> */}
                                        <Option value={"SubAffiliate"}>{this.props.intl.messages.sub_affiliate}</Option>
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.firstName}>
                                {getFieldDecorator('firstName', {
                                    rules: [
                                        { required: true, message: this.props.intl.messages.required_field },
                                        { pattern: RegularExpression.ONLY_LETTERS, message: this.props.intl.messages.only_letters },
                                    ],
                                })(
                                    <Input type="text" />
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.lastName}>
                                {getFieldDecorator('lastName', {
                                    rules: [
                                        { required: true, message: this.props.intl.messages.required_field },
                                        { pattern: RegularExpression.ONLY_LETTERS, message: this.props.intl.messages.only_letters },
                                    ],
                                })(
                                    <Input type="text" />
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.email}>
                                {getFieldDecorator('email', {
                                    rules: [
                                        { required: true, message: this.props.intl.messages.required_field },
                                        { pattern: RegularExpression.EMAIL_VALIDATION, message: this.props.intl.messages.invalid_mail },
                                    ],
                                })(
                                    <Input type="text" />
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.select_language}>
                                {getFieldDecorator('languageId', {
                                    rules: [{
                                        required: true,
                                        message: this.props.intl.messages.required_field
                                    }],
                                })(
                                    <Select className='ta-w100'>
                                        {languages}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </Form>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        affiliates: state.affiliates,
        domains: state.domains,
        user: state.user,
        affUser: state.affUser,
        languages: state.languages,
        currencies: state.currencies,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(AddUser)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Users/AddUser.js